import { default as domainUser } from './user/services' 
import { default as domainAccessLogin } from './login/services'

export default { 
	domainUser,
	domainAccessLogin
}
